<template>
  <div>
    <div class="head-box">
      <div class="box-left-header">
        <div @click="$router.push({ path: '/NewPayments' })" class="goBack c-position-static c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>新增支付</span>
          <i class="el-icon-s-finance"></i>
        </div>
      </div>
      <div class="c-flex">
        <el-input
          style="width: 330px"
          placeholder="请输入委托人/手机号/工单标题/工单编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data">
          <el-table-column fixed="right" width="220" label="操作">
            <template slot-scope="scope">
              <el-button
                @click="editBtn(scope.row)"
                size="mini"
                v-if="formatterOptionBtn(scope.row.auditstate).edit"
              >
                修改
              </el-button>
              <el-button
                @click="submitBtn(scope.row)"
                size="mini"
                v-if="formatterOptionBtn(scope.row.auditstate).submit"
              >
                提交
              </el-button>
              <el-button
                @click="deleteBtn(scope.row)"
                size="mini"
                v-if="formatterOptionBtn(scope.row.auditstate).delete"
              >
                删除
              </el-button>
              <el-button
                @click="withdrawBtn(scope.row)"
                size="mini"
                v-if="scope.row.price > 0 && formatterOptionBtn(scope.row.auditstate).withdraw"
              >
                撤回
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="_id" label="流水号" width="160px"></el-table-column> -->
          <el-table-column
            prop="executor"
            label="申请人"
            width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="tradeIn"
            label="支付类型"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterTradeIn"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterPaymentRecordType"
          ></el-table-column>
          <el-table-column prop="price" label="本次审核金额" width="150px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="`${scope.row.price < 0 ? 'color:red' : 'color:#000'}`">
                {{ osg.amountFilter(scope.row.price) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="refundFee"
            label="退款金额"
            width="150px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{osg.amountFilter(scope.row.refundFee)}}
            </template>          
          </el-table-column>
          <!-- <el-table-column
            prop="payState"
            label="收款状态"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterPayState"
          ></el-table-column> -->
          <el-table-column
            prop="payType"
            label="付款方式"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterPayType"
          ></el-table-column>
          <el-table-column
            prop="auditstate"
            label="审核状态"
            width="130px"
            :formatter="formatterAuditstate"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            prop="createTime"
            label="创建时间"
            width="150px"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            prop="orderType"
            label="款项类型"
            width="150px"
            show-overflow-tooltip
            :formatter="formatterOrderType"
          ></el-table-column>
          <el-table-column
            prop="payTime"
            label="付款时间"
            min-width="160px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="tradeNo"
            label="交易编号"
            width="210px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="exts.payCarryOverMoney"
            label="结转金额"
            min-width="160px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{osg.amountFilter(scope.row.exts.payCarryOverMoney)}}
            </template>          
          </el-table-column>
          <el-table-column
            prop="exts.payCarryOverTime"
            label="结转时间"
            min-width="160px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="memo"
            label="备注"
            min-width="160px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="comments"
            label="审批批语"
            min-width="160px"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <template v-for="(extFiel, index) in extFields">
            <el-table-column
              min-width="180px"
              show-overflow-tooltip
              :label="extFiel.nameDisp"
              :key="index"
              v-if="!extFiel.frontEndConfig || !extFiel.frontEndConfig.listHide"
            >
              <template slot-scope="scope">
                {{ formatterCodelabel(scope.row.exts[extFiel.name], extFiel.valueOption) }}
              </template>
            </el-table-column>
          </template> -->
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="修改"
      :visible.sync="openDetail"
      id="paymentDetailDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="200px"
        label-position="left"
        hide-required-asterisk:true
      >
        <!-- class="c-pointer-n" -->
        <el-form-item
          :label="
            payType == 1
              ? '支付金额'
              : `退款金额 [${formData.price || 0}/${orderList[0].paidAmount}]`
          "
          prop="price"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '金额不能为空'
          }"
        >
          <el-input-number
            type="number"
            :precision="2"
            :controls="false"
            v-model="formData.price"
            :max="payType == 1 ? Infinity : formData.paidAmount"
            placeholder="请输入金额"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          :label="(payType == 1 ? '付款' : '退款') + '人姓名'"
          prop="executor"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '姓名不能为空'
          }"
        >
          <el-input v-model="formData.executor" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          :label="(payType == 1 ? '付款' : '退款') + '方式'"
          prop="payType"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '方式不能为空'
          }"
        >
          <el-select v-model="formData.payType" placeholder="请选择方式">
            <template v-for="item in options.payType">
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-if="item.value != 0"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          label="款项类型"
          prop="orderType"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '款项类型不能为空'
          }"
        >
          <el-select v-model="formData.orderType" placeholder="请选择款项类型">
            <!-- <el-option
              v-for="item in options.orderPayType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span v-if="payType != -1 ? item.value != '0' : item.value == '0'">{{
                item.label
              }}</span>
            </el-option> -->
            <template v-for="item in options.orderPayType">
              <el-option
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-if="payType != -1 ? item.value != '0' : item.value == '0'"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="payType == 1"
          :label="(payType == 1 ? '付款' : '退款') + '时间'"
          prop="payTime"
          placeholder="请选择时间"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '时间不能为空'
          }"
        >
          <el-date-picker
            v-model="formData.payTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>

        <el-form-item
          v-if="payType == 1"
          label="交易编号"
          prop="tradeNo"
          :rules="{
            required: payType != 1 || formData.payType == 4 ? false : true,
            trigger: 'blur',
            message: '交易编号不能为空'
          }"
        >
          <el-input type="number" placeholder="交易编号" v-model="formData.tradeNo"></el-input>
        </el-form-item>

        <el-form-item
          label="备注"
          prop="memo"
          :rules="{
            required: formData.orderType == 0 ? true : false,
            trigger: 'blur',
            message: '备注不能为空'
          }"
        >
          <el-input
            type="textarea"
            :placeholder="payType == 1 ? '备注' : '退款内容及原因'"
            v-model="formData.memo"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="payType == -1"
          label="退款说明类型"
          prop="memo"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '退款说明类型不能为空'
          }"
        >
          <el-select v-model="formData.refundType" placeholder="请选择退款说明类型">
            <template v-for="item in options.contractRefundType">
              <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="payType == -1"
          label="退款说明签约类型"
          prop="memo"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '退款说明签约类型不能为空'
          }"
        >
          <el-select v-model="formData.supplementTreatyType" placeholder="请选择">
            <template
              v-for="item in [
                {
                  label: '线上',
                  value: '0'
                },
                { label: '线下', value: '1' }
              ]"
            >
              <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- <el-table :data="orderList" style="width: 100%">
        <el-table-column fixed prop="ownerName" label="委托方" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.exts.clientname || scope.row.exts.companyName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="ownerPhone"
          label="委托方手机号"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.exts.agentPhone || scope.row.exts.telphone || scope.row.ownerPhone }}
          </template>
        </el-table-column>
        <el-table-column
          prop="contractNum"
          label="合同编号"
          min-width="220"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalPrice"
          label="总金额"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="paidAmount"
          label="已收款金额"
          min-width="160px"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          min-width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="本次支付金额" width="400">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.paymentItemsVal"
              type="number"
              placeholder="请输入金额"
              @input="paymentItemsChange($event, scope.row)"
              @blur="paymentItemsBlur(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
      </el-table> -->
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'paymentDetail',
  data() {
    return {
      name: 'paymentDetail',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_auditstate: { codeId: 'auditstate' },
        codecfg_payState: { codeId: 'payState' },
        codecfg_payType: { codeId: 'payType' },
        codecfg_PaymentRecordType: { codeId: 'PaymentRecordType' },
        codecfg_orderPayType: { codeId: 'orderPayType' },
        codecfg_tradeIn: { codeId: 'tradeIn' }
      },
      params: {},
      orderList: [{}], //订单列表
      SAid: '', //工单id
      contractNum: '', //合同编号
      payType: ''
      // currentRefundableAmount: 0 //当前可退款金额
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    window.$this = this;
    this.SAid = this.osg.param('id');
    this.contractNum = this.osg.param('contractNum');
    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'serviceAppointment',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'asc'
      },
      res => {
        this.options = this.options || [];
        //扩展字段选项关联字典表的查询出选项数据
        for (var item of res.data) {
          //解析frontEndConfig字段配置
          if (item.frontEndConfig && this.osg.isJson(item.frontEndConfig)) {
            item.frontEndConfig = JSON.parse(item.frontEndConfig);
          }
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          //级联
          if (item.type == 'cascade')
            this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
        }
        // this.extFields = res.data;
        this.osg.codeoption(() => {
          this.getData();
        });
      },
      { noload: true }
    );
  },
  methods: {
    getData(callBack) {
      if (!this.SAid) return;
      this.params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:title|string#or': this.searchValue,
        'regex:orderNum|string#or': this.searchValue,
        // 'is:serviceAppointmentId|string#and': this.SAid,
        // 'is:paymentItems|map#and': this.SAid,
        // '`is:paymentItems[${this.SAid}]|map#and`': this.SAid,
        orderId: this.SAid,
        contractNum: this.contractNum,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // this.params[`gt:paymentItems.${this.SAid}|map#and`] = 0;
      this.osg.ajax('i/pay/queryThroughOrderId.do', this.params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
        if (callBack) callBack();
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    //输入支付金额改变
    paymentItemsChange(value, row) {
      if (!this.formData.paymentItems) this.formData.paymentItems = {};
      this.formData.paymentItems[row._id] = this.keepDecimals(value);
    },
    //细项金额保留两位小数
    paymentItemsBlur(row) {
      row.paymentItemsVal = +this.keepDecimals(row.paymentItemsVal).toFixed(2);
    },
    //金额保留两位小数
    priceBlur() {
      this.formData.price = +this.keepDecimals(this.formData.price).toFixed(2);
    },
    //保留两位小数
    keepDecimals(num) {
      return +(Math.round(num * 100) / 100).toFixed(2);
    },
    doSave() {
      if (this.osg.validate()) {
        if (this.formData.orderType == 0) {
          // if (this.formData.price <= 0) {
          //   this.osg.toast('退款金额需大于0 ！', 'error');
          //   return;
          // }
          if (this.orderList[0].paidAmount < Math.abs(this.formData.price)) {
            this.osg.toast('退款金额需小于或等于已收款金额 ！', 'error');
            return;
          }
          this.formData.price = -Math.abs(this.formData.price);
          // if (this.formData.price < 0) {
          //   this.osg.toast('退款金额需大于或等于0 ！', 'error');
          //   return;
          // }
        } else {
          this.formData.price = Math.abs(this.formData.price);
          if (this.formData.price <= 0) {
            this.osg.toast('支付金额需大于0 ！', 'error');
            return;
          }
        }
        this.formData.paymentItems = {
          [Object.keys(this.formData.paymentItems)[0]]: this.formData.price
        };
        this.osg.ajax('i/pay/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    getOrder(row, options, callBack) {
      let SAparams = {
        'is:serviceAppointmentId|string#and': row._id
      };
      let orderParams = {};
      //根据工单id过滤
      if (options.SA) {
        this.formData.serviceAppointmentId = row._id;
      } else {
        SAparams = {};
      }
      //根据订单ids过滤
      if (options.paymentItems) {
        let orderIds = [];
        for (let key in row.paymentItems) {
          orderIds.push(key);
        }
        orderParams = {
          'in:_id|array#and': orderIds.join()
        };
      } else {
        orderParams = {};
      }
      this.params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'is:type|integer#and': 1,
        'is:state|integer#and': 1
      };
      this.params = Object.assign(this.params, SAparams, orderParams);
      this.osg.ajax('basic/order/query.do', this.params, res => {
        if (res && res.data) {
          //对paymentItems字段重构结构,Object转为string
          for (let orderId in row.paymentItems) {
            res.data.map(item => {
              if (item._id == orderId) item.paymentItemsVal = row.paymentItems[orderId];
            });
          }
          this.orderList = res.data;
        }
        if (callBack) callBack();
      });
    },
    //操作按钮-编辑
    editBtn(row) {
      this.getOrder(row, { SA: false, paymentItems: true }, () => {
        this.openDetail = true;

        row = this.$util.deepCopy(row);
        row.orderType = String(row.orderType);
        row.payType = String(row.payType);
        this.payType = row.price > 0 ? 1 : -1;
        this.formData = row;
        this.formData.price = Math.abs(Number(this.formData.price)); //取绝对值
        // if (!(this.formData.orderType != 0)) {
        //   // 点击退款
        //   this.currentRefundableAmount =
        //     this.amountToFixed(this.formData.price) - this.amountToFixed(this.formData.refundFee);
        // }

        this.formData.auditstate = '1';
      });
    },
    //操作按钮-提交
    submitBtn(row) {
      this.osg.confirm('是否确认提交?', () => {
        this.formData = row;
        this.formData.auditstate = '1';
        this.osg.ajax('i/pay/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('提交成功！');
        });
      });
    },
    //操作按钮-删除
    deleteBtn(row) {
      this.osg.confirm('是否确认删除?', () => {
        this.osg.ajax(`i/pay/delete/${row._id}.do`, this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('删除成功！');
        });
      });
    },
    //操作按钮-撤回
    withdrawBtn(row) {
      this.osg.confirm('是否确认撤回?', () => {
        this.formData = row;
        this.formData.auditstate = '99';
        this.osg.ajax('i/pay/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('撤回成功！');
        });
      });
    },
    formatterCodelabel(cellValue, valueOption) {
      if (valueOption) {
        return this.osg.codelabel(valueOption, cellValue);
      } else {
        return cellValue;
      }
    },
    formatterOptionBtn(value) {
      //按钮显示隐藏状态
      let optionBtn = {
        edit: false, //修改
        submit: false, //提交
        delete: false, //删除
        withdraw: false //撤回
      };
      //自由态
      if (value == '99') {
        optionBtn.submit = true;
        optionBtn.edit = true;
        optionBtn.delete = true;
        //提交态
      } else if (value == '1') {
        optionBtn.withdraw = true;
        //审核不通过
      } else if (value == '0') {
        optionBtn.submit = true;
        optionBtn.edit = true;
        optionBtn.delete = true;
      }
      return optionBtn;
    },
    //保留两位小数的金额
    amountToFixed(money) {
      if (!money) return 0;
      let resultAmount = +(+money).toFixed(2);
      return resultAmount ? resultAmount : 0;
    },
    formatterPaymentRecordType(row) {
      if (!row) return '未知';
      return row.price > 0 ? '支付' : '退款';
    },
    formatterPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    formatterPayType(row, column, cellValue) {
      return this.osg.codelabel('payType', cellValue);
    },
    formatterOrderType(row, column, cellValue) {
      return this.osg.codelabel('orderPayType', cellValue);
    },
    formatterAuditstate(row, column, cellValue) {
      return this.osg.codelabel('auditstate', cellValue);
    },
    formatterTradeIn(row, column, cellValue) {
      return this.osg.codelabel('tradeIn', cellValue);
    }
  }
};
</script>
<style>
#app #paymentDetailDialog .el-dialog {
  width: 76% !important;
  min-width: 400px;
  max-width: 95%;
  max-height: 80vh;
  margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
</style>
<style scoped>
input.el-input__inner {
  width: 230px;
}
</style>
